import { Slider, Props as SliderProps } from 'builder/components/DocumentEditor/Slider'
import * as Styles from './styles'

type OnChange = (value: number) => void

type Props = {
  name: string
  value: number
  unit?: string
  displayValue?: string
  onChange: OnChange
} & Omit<SliderProps, 'onChange'>

export const SlideInput = (props: Props) => {
  const { name, unit, displayValue, onChange, ...sliderProps } = props

  const getDisplayValue = () => {
    if (displayValue) return displayValue

    if (unit === '%') {
      const percentage = 100 + sliderProps.value * 50
      return `${Math.round(percentage)}%`
    }
    return unit ? `${sliderProps.value} ${unit}` : `${sliderProps.value}`
  }

  return (
    <Styles.Container>
      <Styles.NameContainer>
        <Styles.NameText>{name}</Styles.NameText>
      </Styles.NameContainer>
      <Styles.InputContainer>
        <Styles.SliderContainer>
          <Slider onChange={onChange as SliderProps['onChange']} {...sliderProps} />
        </Styles.SliderContainer>
        <Styles.ValueContainer disabled={sliderProps.disabled}>
          <Styles.TextValue>{getDisplayValue()}</Styles.TextValue>
        </Styles.ValueContainer>
      </Styles.InputContainer>
    </Styles.Container>
  )
}
